import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import * as Styles from "../../constants/StyleConstants";
import Button from "./Button.js";
import mergeDeep from "../../util/mergeDeep";

class RepeatingFieldset extends React.Component {
    constructor(props) {
        super(props);
        this.state = { isHovered: false };
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
    }

    onMouseEnter(e) {
        this.setState({ isHovered: true });
    }

    onMouseLeave(e) {
        this.setState({ isHovered: false });
    }

    render() {
        const { children, onAddClick, onRemoveClick, isDisabled, entityName, isMinButtonEnabled, isPlusButtonEnabled, simpleButtons } = this.props;

        const buttonStyle = { width: "100%", minHeight: "4.5em" };

        const fieldsetContentClassName = classnames({
            "c-fieldset__content": true,
            "dashed": this.state.isHovered
        });
        const minButtonWrapperClassNames = classnames({
            "o-col-3": !simpleButtons,
            "o-col-1": simpleButtons,
            "o-col-push-6": !simpleButtons && (isPlusButtonEnabled && isMinButtonEnabled),
            "o-col-push-9": !simpleButtons && (!isPlusButtonEnabled && isMinButtonEnabled),
            "o-col-push-10": simpleButtons
        });
        const plusButtonWrapperClassNames = classnames({
            "o-col-3": !simpleButtons,
            "o-col-1": simpleButtons,
            "o-col-push-9": !simpleButtons && (isPlusButtonEnabled && !isMinButtonEnabled),
            "o-col-push-11": simpleButtons && !isMinButtonEnabled
        });

        const minButtonWrapperProps = {
            className: minButtonWrapperClassNames,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        };

        const plusButtonWrapperProps = {
            className: plusButtonWrapperClassNames,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        };

        let containerProperties = mergeDeep({}, {
            className: fieldsetContentClassName,
            style: this.state.isHovered ? Styles.highlightedRowContainerStyle : Styles.rowContainerStyle
        });

        containerProperties.style['clear'] = "both";

        const minusButton = simpleButtons ? <Button className="c-button--input min" onClick={onRemoveClick} disabled={isDisabled}>-</Button> : <Button style={buttonStyle} onClick={onRemoveClick} disabled={isDisabled}>Verwijder {entityName} -</Button>;
        const plusButton = simpleButtons ? <Button className="c-button--input plus" onClick={onAddClick} disabled={isDisabled}>+</Button> : <Button style={buttonStyle} onClick={onAddClick} disabled={isDisabled}>Voeg {entityName} toe +</Button>;

        return (<div style={{ marginBottom: "15px" }}>
            <div {...containerProperties}>
                {children}
            </div>
            <div className="c-fieldset__actions" style={{ marginTop: "15px" }}>
                <div className="u-clear">
                    {isMinButtonEnabled ? <div {...minButtonWrapperProps}>
                        {minusButton}
                    </div> : null}
                    {isPlusButtonEnabled ? <div {...plusButtonWrapperProps}>
                        {plusButton}
                    </div> : null}
                </div>
            </div>
        </div>);
    }
}

RepeatingFieldset.propTypes = {
    children: PropTypes.node.isRequired,
    onAddClick: PropTypes.func.isRequired,
    onRemoveClick: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool,
    entityName: PropTypes.string,
    isMinButtonEnabled: PropTypes.bool,
    isPlusButtonEnabled: PropTypes.bool,
    simpleButtons: PropTypes.bool
};
RepeatingFieldset.defaultProps = {

};
export default RepeatingFieldset;